// extracted by mini-css-extract-plugin
export default {"infoItem":"styles_infoItem__+yoKy"};